import { Autocomplete, FormControl, IconButton, Paper, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { KnowledgeCenterStyle } from './knowledgeCenter.styles';
import React from 'react';
import { map, startWith } from 'rxjs';
import SearchIcon from '@mui/icons-material/Search';
import { checkIsInternal } from '@src/utility/createStorage';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import { ArrowForwardIos } from '@mui/icons-material';
import { StorageService } from '@src/utility/storage.service';
import { ANALYTICS_EVENTS } from '@src/apps/constants/constant';

function GlossaryComponent(props) {
  const storageService = new StorageService();
  const [glossaryList, setGlossaryList]: Array<any> = useState(props.glossaryList);

  const [glossarySelected, setGlossarySelected]: Array<any> = useState([]);
  const [options, setOptions]: Array<any> = useState([]);
  const [filteredOptions, setFilteredOptions]: Array<any> = useState([]);
  // const [glossaryCtrl, setGlossaryCtrl] = useState(new FormControl());
  const [allmetrics, setAllMetrics] = useState(false);
  const [allmetricsdefinitionShort, setAllMetricsDefinitionShort]: Array<any> = useState(
    []
  );
  const [optionND, setOptionND] = useState(false);
  const [focused, setFocused] = useState(false);
  const [toHighlight, setToHighlight] = useState('');
  const [internal, setInternal] = useState(checkIsInternal());
  const [selectedGlossaryOption, setSelectedGlossaryOption] = useState<any>(null);
  const [internalMetricIndicator, setInternalMetricIndicator] = useState(false);
  const [externalMetricIndicator, setExternalMetricIndicator] = useState(false);
  const [expandedDataSource, setExpandedDataSource] = useState<{ [key: number]: boolean }>({});
  const [simulationMode, setSimulationMode] = useState(
    sessionStorage.getItem('simulationMode') === 'true'
  );
  const [isPreview, setIsPreview] = useState(false);
  const { isPreviewKC } = props
  const [isMetrictDefinitionBreadCrumb, setIsMetrictDefinitionBreadCrumb] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  useEffect(() => {
    getGlossaryData();
  }, [props]);
  useEffect(() => {
    if (glossarySelected && glossarySelected.length > 0) {
      glossarySelected.forEach(item => {
        getMetricIndicator(item);
      });
    }
  }, [glossarySelected]);
  const sortObjArray = (array, param) => {
    let result;
    if (array) {
      array.sort((a, b) => {
        if (a[param] < b[param]) {
          result = -1;
        } else if (a[param] > b[param]) {
          result = 1;
        } else {
          result = 0;
        }
        return result;
      });
    }

    return array;
  }
  const getGlossaryData = async () => {
    setGlossaryList(sortObjArray(props.glossaryList, 'MetricName'));
    if (!(props.glossaryList instanceof Array) || props.glossaryList.length === 0) {
      return;
    }

    setGlossaryList(props.glossaryList.map((glossaryListItem: any) => {
      glossaryListItem.readmore = true;
      return glossaryListItem;
    }));

    if (props?.metricId === 'ALL') filteredData('All');
    else getGlossarySelected();
    setTimeout(() => setIsLoader(false), 1000);
    getGlossaryList();
  }

  const getGlossaryList = () => {
    const _options = props.glossaryList.map((glossary, index) => ({
      MetricName: glossary?.MetricName,
      SubMetric: glossary?.SubMetric || null,
      SubMetricId: glossary?.SubMetricId || null,
      Category: glossary?.Category || null,
      MetricId: glossary?.MetricId || null,
      index,
    }));
    setOptions(_options);
    setFilteredOptions(_options);
    const results = {};
    for (let i = 0; i < 26; i++) {
      const char = String.fromCharCode(97 + i);
      const bigChar = char.toUpperCase();
      results[bigChar] = [];
      for (let s = 0; s < props.glossaryList.length; s++) {
        if (props.glossaryList[s].MetricName.startsWith(bigChar)) {
          results[bigChar].push(props.glossaryList[s].MetricName);
        }
      }
    }
  }

  const getGlossarySelected = () => {
    const glossarySelected = props.glossaryList.filter((glossaryItem: any) => {
      const MetricId = glossaryItem.MetricId;
      const MetricName = glossaryItem.MetricName;
      let metricIdExists = false;
      if (props.metricId) {
        const metricIds = String(props.metricId).split(',');
        metricIdExists = metricIds.filter((metricId: string) => {
          return metricId.toString() === MetricId.toString();
        })[0]
          ? true
          : false;
        return metricIdExists;
      }

      const metricName = props.title;

      const metricNameExists = MetricName?.toUpperCase() === metricName?.toUpperCase();

      return metricNameExists;
    });
    setGlossarySelected(glossarySelected);
  }

  const getMetricIndicator = (glossarySelected) => {
    if (
      glossarySelected['MetricDefinition'] &&
      glossarySelected['MetricDefinition'].MetricAvailableIn &&
      glossarySelected['MetricDefinition'].MetricAvailableIn !== null
    ) {
      const metricAvailableIn = glossarySelected['MetricDefinition']['MetricAvailableIn'];
      if (metricAvailableIn.includes('Internal')) {
        setInternalMetricIndicator(true);
      }
      if (
        metricAvailableIn.includes('External_A') ||
        metricAvailableIn.includes('External_All') ||
        metricAvailableIn.includes('External_B') ||
        metricAvailableIn.includes('External')
      ) {
        setExternalMetricIndicator(true);
      } else {
        setExternalMetricIndicator(false);
      }
    }
  }

  const getInteractionContext = () => {
    if (props?.title) {
      return props.title;
    }

    const metricIds = String(props?.metricId || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    if (metricIds.length && Array.isArray(props?.glossaryList)) {
      const matchedMetric = props.glossaryList.find((item) =>
        metricIds.includes(String(item?.MetricId))
      );

      if (matchedMetric?.MetricName) {
        return matchedMetric.MetricName;
      }
    }

    if (Array.isArray(glossarySelected) && glossarySelected[0]?.MetricName) {
      return glossarySelected[0].MetricName;
    }

    return undefined;
  }

  const filteredData = (value) => {
    if (!value) {
      return null;
    }
    if (value === 'All') {
      storageService.setAppEventDataLayerForAdobeOnInteraction({
        interactionName: 'Knowledge Center',
        interactionValue: 'view all metrics',
        interactionContext: getInteractionContext(),
      });
      for (let i = 0; i < props.glossaryList.length; i++) {
        if (getTextWidth(props.glossaryList[i].MetricDefinition?.Definition, 16, 'Arial') > 680) {
          setAllMetricsDefinitionShort(props.glossaryList[i].MetricDefinition?.Definition.slice(0, 90) + '...');
        } else {
          setAllMetricsDefinitionShort(null);
        }
      }
      setAllMetrics(true);
      setGlossarySelected(props.glossaryList);
      if (props?.metricId === 'ALL' && isMetrictDefinitionBreadCrumb) {
        setIsMetrictDefinitionBreadCrumb(false);
        readmore(-1);
      }
    } else {
      setAllMetrics(false);
      let selectedGlossaryItem = null;

      if (value && typeof value !== 'string' && typeof value.index === 'number') {
        selectedGlossaryItem = props.glossaryList[value.index] || null;
      }

      if (!selectedGlossaryItem && value && typeof value !== 'string') {
        selectedGlossaryItem = props.glossaryList.find((item) => {
          const sameMetric = item?.MetricName === value?.MetricName;
          const sameSubMetric = (item?.SubMetric || null) === (value?.SubMetric || null);
          const sameCategory = (item?.Category || null) === (value?.Category || null);
          return sameMetric && sameSubMetric && sameCategory;
        }) || null;
      }

      if (!selectedGlossaryItem && typeof value === 'string') {
        const selectedName = value;
        selectedGlossaryItem = props.glossaryList.find((item) =>
          item?.SubMetric ? item.SubMetric === selectedName : item?.MetricName === selectedName
        ) || null;
      }

      if (selectedGlossaryItem) {
        setGlossarySelected([selectedGlossaryItem]);
        getMetricIndicator(selectedGlossaryItem);
      }
      if (props?.metricId === 'ALL') {
        setIsMetrictDefinitionBreadCrumb(true);
        const parentDiv = document.getElementById('each-metric-div0')?.parentElement;
        if (parentDiv)
          parentDiv.style.display = 'block';
      }

      return selectedGlossaryItem;
    }

    return null;
  }
  const readmore = (value) => {
    if (value >= 0) {
      storageService.setAppEventDataLayerForAdobeOnInteraction({
        interactionName: 'view all metrics',
        interactionValue: 'read more',
        interactionContext: ANALYTICS_EVENTS.KNOWLEDGE_CENTER,
      });
    }
    const metricDivClass = 'each-metric-div';
    setGlossaryList(props.glossaryList.map((glossaryListItem: any, index: number) => {
      glossaryListItem.readmore = true;
      document.getElementById(metricDivClass + index)?.classList.add(metricDivClass);
      if (index === value) {
        glossaryListItem.readmore = false;
        document.getElementById(metricDivClass + index)?.classList.remove(metricDivClass);
        if (props?.metricId === 'ALL') {
          setIsMetrictDefinitionBreadCrumb(true);
          document.querySelectorAll('.each-metric-border').forEach((element, elementIdx) => (elementIdx !== value) && ((element as any).style.display = 'none'));
        }
      }
      return glossaryListItem;
    }));
    if (value === -1) {
      setAllMetrics(true);
      setGlossarySelected(props.glossaryList);
      const intervalRef = setInterval(() => {
        const eachMetricBorderDiv = document.querySelectorAll('.each-metric-border');
        if (eachMetricBorderDiv.length) {
          clearInterval(intervalRef);
          eachMetricBorderDiv.forEach((element) => ((element as any).style.display = 'block'));
        }
      });
    }
  }
  const getTextWidth = (text, fontSize, fontFace) => {
    const canvas = document.createElement('canvas');
    const context: any = canvas.getContext('2d');
    context.font = fontSize + 'px ' + fontFace;
    return context.measureText(text).width;
  }
  const handleInputChange = (event, value) => {
    setToHighlight(value);
    const filtered = options.filter((option) =>
      option.MetricName.toLowerCase().startsWith(value.toLowerCase()) ||
      (option.SubMetric && option.SubMetric.toLowerCase().startsWith(value.toLowerCase()))
    );
    setFilteredOptions(filtered);
    setOptionND(filtered.length === 0);
  };
  const navigateTo = (url: string) => {
    window.location.href = url;
  };

  const toggleDataSource = (index: number) => {
    setExpandedDataSource(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  return (
    <React.Fragment>
      <KnowledgeCenterStyle>
        <div className="business-glossary">
          {isLoader ? <LoaderComponent className='wc-skeleton' style={{ height: '90vh' }} />
            : <div className="metrics-div" id="metrics-div">

              {/* BreadCrumb ---start */}
              {props?.metricId === 'ALL' && (<div className="breadcrumb-bdr">
                <ol className="KC-breadcrumb">
                  <li>
                    <div onClick={() => props?.toggleWelcomeKC(true)} className="text-link">Overview</div>
                    <span className="disable-arrow"><ArrowForwardIos style={{ fontSize: '1rem' }} /></span>
                  </li>
                  <li>
                    <div className={isMetrictDefinitionBreadCrumb ? 'text-link' : 'disable-link'} onClick={() => { setIsMetrictDefinitionBreadCrumb(false); readmore(-1); }}>
                      Metric Definitions {isMetrictDefinitionBreadCrumb && <span className="disable-arrow"><ArrowForwardIos style={{ fontSize: '1rem' }} /></span>}
                    </div>
                  </li>
                  {isMetrictDefinitionBreadCrumb && (<li>
                    <span className="disable-link"> Current Definition</span>
                  </li>)}
                </ol>
              </div>)}
              {/* BreadCrumb ---end */}

              <input type="text" autoFocus style={{ opacity: 0 }} />
              <div
                className="autocomplete-section"
                style={{
                  display: internal && !simulationMode ? 'block' : 'none',
                }}
              >
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    freeSolo={toHighlight?.length ? false : true}
                    options={filteredOptions}
                    filterOptions={(x) => x}
                    value={selectedGlossaryOption}
                    getOptionLabel={(option: any) =>
                      typeof option === 'string'
                        ? option
                        : option?.SubMetric || option?.MetricName || ''
                    }
                    onInputChange={handleInputChange}
                    onChange={(event, value) => {
                      const selectedGlossaryItem = filteredData(value);
                      const selectedLabel = selectedGlossaryItem?.SubMetric || selectedGlossaryItem?.MetricName || null;
                      setSelectedGlossaryOption(selectedLabel || value || null);
                    }}

                    PaperComponent={({ children }) => {
                      return (
                        <Paper onMouseDown={(event) => event.preventDefault()}>
                          <KnowledgeCenterStyle>
                            {children}
                            {filteredOptions.length === 0 && (
                              <div style={{ paddingLeft: "16px", position: 'relative', top: '-16px' }} className='mat-option-text'>
                                No Results Found For{' '}
                                <strong>{toHighlight}</strong>
                              </div>
                            )}
                            <div
                              className="view-allMetrics"
                              onClick={() => filteredData('All')}
                            >
                              View All Metrics
                            </div>
                          </KnowledgeCenterStyle>
                        </Paper>
                      );
                    }}

                    renderInput={(params) => {
                      return !focused ? <TextField
                        {...params}
                        label="What metrics can we help you with?"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <IconButton>
                              <SearchIcon style={{ color: 'black' }} />
                            </IconButton>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: focused,
                          style: { paddingLeft: '35px' }
                        }}
                        onFocus={() => setFocused(true)}
                        fullWidth
                      /> : <TextField
                        {...params}
                        label="What metrics can we help you with?"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <IconButton>
                              <SearchIcon style={{ color: 'black' }} />
                            </IconButton>
                          ),
                        }}

                        onFocus={() => setFocused(true)}
                        fullWidth
                      />
                    }}
                    renderOption={(props, option: any) => {
                      const metricName = typeof option === 'string' ? option : option?.MetricName;
                      const subMetric = typeof option === 'string' ? null : option?.SubMetric;
                      const category = typeof option === 'string' ? null : option?.Category;
                      const highlight = (text: string) =>
                        text.replace(
                          new RegExp(toHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'),
                          (match) => `<strong>${match}</strong>`
                        );
                      return (
                        <li {...props} key={props.id} style={{ minHeight: '48px', height: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', padding: '8px 16px', boxSizing: 'border-box' }}>
                          {subMetric ? (
                            <>
                              <span
                                className="mat-option-text"
                                dangerouslySetInnerHTML={{ __html: highlight(subMetric) }}
                              />
                              <span
                                className="mat-option-text"
                                style={{ fontSize: '12px', color: '#757588', lineHeight: '16px', marginTop: '2px' }}
                                dangerouslySetInnerHTML={{ __html: highlight(metricName) }}
                              />
                            </>
                          ) : (
                            <>
                              <span
                                className="mat-option-text"
                                dangerouslySetInnerHTML={{ __html: highlight(metricName) }}
                              />
                              {category && (
                                <span
                                  className="mat-option-text"
                                  style={{ fontSize: '12px', color: '#757588', lineHeight: '16px', marginTop: '2px' }}
                                  dangerouslySetInnerHTML={{ __html: highlight(category) }}
                                />
                              )}
                            </>
                          )}
                        </li>
                      );
                    }}
                    noOptionsText={null}
                    ListboxProps={{
                      style: { maxHeight: '300px', overflow: 'auto' },
                    }}
                  />
                </FormControl>

              </div>

              {glossarySelected.length > 0 && (
                <div>{(allmetrics && !isMetrictDefinitionBreadCrumb) && (
                  <div className="view-all-metrics-title">{props?.metricId === 'ALL' ? 'Metric Definitions' : 'View All Metrics'}</div>)}
                  <div className={(allmetrics && !isMetrictDefinitionBreadCrumb) ? 'all-metrics-glossary-title' : 'glossary-title-react'}>
                    {glossarySelected?.length && glossarySelected[0]?.MetricName}
                  </div>
                  {glossarySelected?.map((glossary, i) => (
                    <>
                      {glossary.SubMetric && <div className="glossary-formula"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          cursor: glossary.SubMetricId ? 'pointer' : 'default',
                          color: '#196ECF', fontSize: '18px', fontWeight: '600',
                          borderBottom: '1px solid #ccc', paddingBottom: '25px'
                        }}
                        onClick={() => glossary.SubMetricId && toggleDataSource(i)}
                      >
                        {glossary.SubMetric ? `${glossary.SubMetric}` : ''}
                        {glossary.SubMetricId && (
                          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {expandedDataSource[i] ? '[-]' : '[+]'}
                          </span>
                        )}
                      </div>}
                      {(!glossary.SubMetricId || expandedDataSource[i]) && (
                        <div key={i} className={(allmetrics && !isMetrictDefinitionBreadCrumb) ? 'each-metric-border' : ''}>
                          <div id={`each-metric-div${i}`} className={allmetrics ? 'each-metric-div' : ''}>
                            <div className="glossary-metric-content-div">
                              <div className="glossary-definition">{!isPreview && (
                                <span dangerouslySetInnerHTML={{
                                  __html: (glossary.MetricDefinition?.Published || (glossary.MetricDefinition?.Published !== undefined && isPreviewKC))
                                    ? glossary.MetricDefinition?.Definition : 'Coming Soon'
                                }} />)}
                              </div>
                              {internal && !simulationMode && (
                                <div className="glossary-definition">
                                  <div className="glossary-formula">
                                    Data Calculation
                                  </div>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: (glossary.MetricDefinition?.Published || (glossary.MetricDefinition?.Published !== undefined && isPreviewKC))
                                        ? glossary.MetricDefinition?.Formula
                                        : 'Coming Soon',
                                    }} />
                                </div>
                              )}
                              {internal && !simulationMode && (
                                <div className="glossary-definition">
                                  <div className="glossary-formula">Data Source</div>
                                  {!isPreview
                                    ? (glossary.MetricDefinition?.Published || (glossary.MetricDefinition?.Published !== undefined && isPreviewKC))
                                      ? glossary.MetricDefinition?.DataSource
                                      : 'Coming Soon'
                                    : ''}
                                </div>
                              )}
                              {internal && !simulationMode && (
                                <div>
                                  <div className="glossary-formula">Refresh Details</div>
                                  <div className="glossary-definition">{glossary.MetricDefinition?.RefreshFrequency}</div>
                                  <div className="glossary-definition" style={{ color: '#757588' }}>Last Refresh: {glossary.MetricDefinition?.RefreshDate}</div>
                                </div>
                              )}
                              {internal && !simulationMode && (
                                <div>
                                  <p className="glossary-formula">
                                    Metric Available in
                                  </p>
                                  <div className="metric-indicator">
                                    {externalMetricIndicator && (
                                      <span className="metric-indicator-external">
                                        External
                                      </span>
                                    )}
                                    {internalMetricIndicator && (
                                      <span className="metric-indicator-internal">
                                        Internal
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                              {internal && !simulationMode && props?.metricId === 'ALL' && (
                                <div className="go-metric-location" onClick={() => navigateTo(glossary?.MetricDefinition?.Location)}>
                                  Go to Metric Location <ArrowForwardIos style={{ fontSize: '1rem' }} />
                                </div>)}
                            </div>
                          </div>
                          <div className="Read-More">{allmetrics && glossary.readmore && (<div onClick={() => readmore(i)}>Read More</div>)}
                            {!glossary.readmore && !isMetrictDefinitionBreadCrumb && (<div className="margin-top-5" onClick={() => readmore(-1)}>Read Less</div>)}
                          </div>
                        </div>)}
                    </>
                  ))}
                </div>
              )}

              {!glossarySelected.length && !isPreview && (
                <div>
                  <div className="glossary-title-react">{props.title}</div>


                  <div className="glossary-definition">Coming Soon</div>
                  {internal && (
                    <div className="glossary-definition">
                      <div className="glossary-formula">Data Calculation</div>
                      Coming Soon
                    </div>
                  )}
                  {internal && (
                    <div className="glossary-definition">
                      <div className="glossary-formula">Data Source</div>
                      Coming Soon
                    </div>
                  )}
                </div>
              )}
            </div>}
        </div>
        {!isPreview && internal && !simulationMode && !allmetrics && !isPreviewKC && props?.metricId !== 'ALL' && (
          <div
            id="view-all-metrics-button-position-div"
            className="view-all-metrics-button-position-div"
          >
            <div className="view-all-metrics-button-div">
              <div
                className="view-all-metrics-button"
                onClick={() => filteredData('All')}
              >
                <span className="view-all-metrics-button-text">
                  View All Metrics
                </span>
              </div>
            </div>
          </div>
        )}
      </KnowledgeCenterStyle>
    </React.Fragment>
  );
}
export default GlossaryComponent;